// "지연 로딩 전용" 로더들을 한 곳에 모읍니다.
// 앱에서 defineAsyncComponent로 감싸 사용.

export const lazyCommReferenceBottomSheet = () => import('./components/common/CommReferenceBottomSheet.vue');

export const lazyCommEvaluationDescBottomSheet = () => import('./components/common/CommEvaluationDescBottomSheet.vue');

// export const lazyCommTrendReportFeedbackCheck = () => import('./components/trendReport/TrendReportFeedbackCheck.vue');
